import format from "date-fns/format";
import { LangCode } from "src/requests/localization/types";
import { ValueFormat } from "src/requests/templates/types";

import { useGetDateFormat, useLocaleCode } from "./utils";

type FormattedDateValueGetter = (
  date: string,
  valueFormat?: ValueFormat
) => string;

const useGetFormattedStringToDateValueGetter = (): FormattedDateValueGetter => {
  const getDateFormat = useGetDateFormat();
  const locale = useLocaleCode();
  const getFormattedStringToDateValue: FormattedDateValueGetter = (
    dateString,
    valueFormat
  ) => {
    if (dateString === "undefined" || !dateString) return "";

    const date = new Date(dateString);
    const dateVariant = valueFormat?.typeSpecific?.date?.variant;
    const defaultDate = format(date, getDateFormat("day only"), { locale });

    if (!dateVariant) {
      return defaultDate;
    }

    switch (dateVariant) {
      case "Date":
        return defaultDate;
      case "DateTime":
        return format(date, getDateFormat("full"), { locale });
      case "Time":
        return format(date, getDateFormat("time only"), { locale });
      case "Month":
        return format(date, "LLLL", { locale });
      case "Year":
        return format(date, "yyyy", { locale });
      default:
        return defaultDate;
    }
  };

  return getFormattedStringToDateValue;
};

export default useGetFormattedStringToDateValueGetter;
